import { useState } from "react";
import QRCode from "react-qr-code";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle'; 
import QRCodeIcon from '@mui/icons-material/QrCode';
import Typography from '@mui/material/Typography';

const QRCodeComponent = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const childProps = {
    variant: 'outlined',
    color: 'primary',
    size: 'medium',
    padding: 1,
    title: 'QR Code',
    ...props,
  };
  return (
    <>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>
          <Typography variant="h2" align='center'>
            {childProps.title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {childProps.description && 
            <Typography variant='body' padding={0.5}> 
              {childProps.description}
            </Typography>
          }
          <Box padding={childProps.padding}>
            {childProps.value && <QRCode value={childProps.value} />}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Button {...childProps} onClick={() => setIsOpen(true)}>
        <QRCodeIcon />
        Show QR Code
      </Button>
    </>
  );
};

export default QRCodeComponent;